import { Box } from '@mui/material';
import './SellingPointCard.css';
import React, { useEffect, useState } from 'react';
import { getIcon } from '../../pages/About/icons';

interface SellingPointCardProps {
    id: string,
    pointTitle: string,
    pointDescription: string,
    iconType: string
}

const SellingPointCard: React.FC<SellingPointCardProps> = ({ id, pointTitle, pointDescription, iconType }) => {

    return (
        <Box className="point-card">
            <Box className="point-card-icon-container">
                <Box className="card-icon" id={`${id}-icon`}>{getIcon(iconType)}</Box>
            </Box>
            <Box className="point-card-container">
                <Box className='card-title-container' id={`${id}-container`}>
                    <Box className="card-title" id={`${id}-title`}
                        sx={{fontSize: { xs: '18px', sm: '20px', md: '22px', lg: '24px' }}}
                    >
                        {pointTitle}
                    </Box>
                </Box>
                <Box className='card-info-container' id={`${id}-container`}>
                    <Box className="card-info" id={`${id}-title`}
                        sx = {{fontSize: { xs: '14px', sm: '16px', md: '17px', lg: '18px' }}}
                    >
                        {pointDescription}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default SellingPointCard;